interface RendererSize {
  width: number;
  height: number;
}

/** Track CSS layout changes as well as device rotation, without remounting the game. */
export function observeSettlementHostSize(
  host: HTMLElement,
  currentSize: () => RendererSize,
  resize: (width: number, height: number) => void,
): () => void {
  let frame: number | undefined;
  let stopped = false;
  const schedule = () => {
    if (stopped || frame !== undefined) return;
    frame = window.requestAnimationFrame(() => {
      frame = undefined;
      if (stopped) return;
      const width = host.clientWidth;
      const height = host.clientHeight;
      if (width <= 0 || height <= 0) return;
      const current = currentSize();
      if (current.width !== width || current.height !== height) resize(width, height);
    });
  };
  const observer = new ResizeObserver(schedule);
  observer.observe(host);
  window.addEventListener('resize', schedule);
  schedule();
  return () => {
    stopped = true;
    observer.disconnect();
    window.removeEventListener('resize', schedule);
    if (frame !== undefined) window.cancelAnimationFrame(frame);
  };
}
